import type { PaymentScopePage } from '../types'
import type { DownPaymentCoveredAnalyticsData, DownPaymentCoveredEvent, PaymentAnalyticsContext, PaymentEvent, PaymentEventData, PaymentMethodAnalyticsData, PaymentMethodEvent, VoucherSelectedEvent, VoucherSelectionAnalyticsData } from './types'

const paymentEventContexts = {
  BookingPayment: 'BookingPaymentPage',
  MandatoryPayment: 'MandatoryPaymentPage',
  Payment: 'PaymentPage',
} as const

export function getPaymentEventContext(scope: PaymentScopePage) {
  return paymentEventContexts[scope]
}

export function createPaymentEvent(data: PaymentEventData): PaymentEvent {
  return {
    event: 'Payment',
    ...data,
  }
}

export function createPaymentMethodEvent(
  data: PaymentMethodAnalyticsData,
  context: PaymentAnalyticsContext = {},
): PaymentMethodEvent {
  return {
    event: 'eec.checkout_option',
    ecommerce: {
      checkout_option: {
        actionField: {
          ...(context.step !== undefined && { step: context.step }),
          option: data.paymentMethod,
          status: `${data.paymentType.toLowerCase()} ${data.amountPaid}`,
          manual: data.manual,
          ...(data.isOwned !== undefined && { isOwned: data.isOwned }),
        },
      },
    },
  }
}

export function createVoucherSelectedEvent(
  data: VoucherSelectionAnalyticsData,
  context: PaymentAnalyticsContext = {},
): VoucherSelectedEvent {
  return {
    event: 'eec.checkout_selected',
    ecommerce: {
      checkout_selected: {
        actionField: {
          ...(context.step !== undefined && { step: context.step }),
          option: 'voucher',
          isOwned: data.isOwned,
        },
      },
    },
  }
}

export function createDownPaymentCoveredEvent(data: DownPaymentCoveredAnalyticsData): DownPaymentCoveredEvent {
  return {
    event: 'rebookingAccount',
    description: 'Down payment covered',
    ...data,
  }
}
